<div class="modal-content">
  <div class="modal-body">
    <div class="modal__header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    
    <div class="modal__title">Verificação de Segurança</div>
   
    <div class="modal__subtitle">Insira o <strong>código</strong> que enviamos para você</div>
    
    <form class="forms modal__form" [formGroup]="form">
      <div class="form-group">
        <div class="inputs">
          <input
            class="form-control modal__input"
            type="text"
            minlength="6"
            maxlength="6"
            formControlName="codigoSeguranca"
            appShowErrorMessages
            required="true"
            name="codigoSeguranca"
            autocomplete="off">
        </div>
      </div>
    </form>
    
    <div class="modal__action">
      <app-gradient-button
        label="Confirmar"
        (click)="onClickConfirm()"
        [isDisabled]="form.invalid">
      </app-gradient-button>
    </div>
  </div>
</div>

